
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[festivalId]/search",
      function () {
        return require("private-next-pages/[festivalId]/search.js");
      }
    ]);
  